/**
 * Entity-kind classification (docs/data-model-completion-strategy.html §4, Phase A).
 *
 * No new doc extraction: this infers `kind` from the entity id's naming
 * suffix alone, so DTOs/props/config entities stop being graded as if they
 * were persisted aggregates by the UNREFERENCED_ENTITY gap rule. Anything
 * not matching a known suffix defaults to 'aggregate' — unchanged behavior.
 */
import type { Entity, EntityKind } from '@atlas-manifest/types';

const PROPS_SUFFIX = 'Props';
const CONFIG_SUFFIX = 'Config';
const DTO_SUFFIXES = ['Request', 'Response', 'Options', 'Input', 'Mapping', 'Payload'];

/** Infers an entity's structural kind from its id's naming suffix. */
export function classifyEntityKind(entityId: string): EntityKind {
  if (entityId.endsWith(PROPS_SUFFIX)) return 'props';
  if (entityId.endsWith(CONFIG_SUFFIX)) return 'config';
  if (DTO_SUFFIXES.some((suffix) => entityId.endsWith(suffix))) return 'dto';
  return 'aggregate';
}

/** Entity.kind when explicitly set, else the naming-heuristic classification. */
export function resolveEntityKind(entity: Entity): EntityKind {
  return entity.kind ?? classifyEntityKind(entity.id);
}
